import { render } from "./GeneralDynamicParametres.vue?vue&type=template&id=99373a56"
import script from "./GeneralDynamicParametres.vue?vue&type=script&lang=js"
export * from "./GeneralDynamicParametres.vue?vue&type=script&lang=js"

import "./GeneralDynamicParametres.vue?vue&type=style&index=0&id=99373a56&lang=css"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__